export const FLAG_POST_REQUEST = 'FLAG_VIDEO/REQUEST';
export const FLAG_POST_SUCCESS = 'FLAG_VIDEO/SUCCESS';
export const FLAG_POST_FAIL = 'FLAG_VIDEO/FAIL';
